import React, { useState } from 'react';
import styles from './styles.module.scss';

interface SlideHeaderProps {
  savingsSubText: string;
  savingsText: string;
  tooltipText: string;
  zipCode?: string;
  totalSavings?: string;
}

const SlideHeader: React.FC<SlideHeaderProps> = ({
  savingsSubText,
  savingsText,
  tooltipText,
  zipCode,
  totalSavings,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const displaySubText = zipCode
    ? `${savingsSubText} per il CAP ${zipCode}`
    : savingsSubText;

  return (
    <div className={styles.slideHeader}>
      <div className={styles.savingsSubText}>{displaySubText}</div>

      <div className={styles.savingsMain}>
        <div className={styles.savingsText}>{savingsText}</div>

        <div
          className={styles.infoIcon}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          onClick={() => setShowTooltip(!showTooltip)}
        >
          i
          <span
            className={`${styles.tooltipText} ${showTooltip ? styles.visible : ''}`}
          >
            {tooltipText}
          </span>
        </div>
      </div>

      {totalSavings && (
        <div className={styles.savingsIndicator}>
          <span>Risparmio totale: </span>
          <strong>{totalSavings}</strong>
        </div>
      )}
    </div>
  );
};

export default SlideHeader;
